'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var produce = require('immer');
var axios = require('axios');
var endpoints = require('@piconetworks/endpoints');
var effects = require('redux-saga/effects');
var networkMiddleware = require('@piconetworks/network-middleware');
var Duck = require('extensible-duck');
var reselect = require('reselect');
var get = require('lodash/get');
var isEmpty = require('lodash/isEmpty');
var template = require('lodash/template');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var Duck__default = /*#__PURE__*/_interopDefaultLegacy(Duck);
var get__default = /*#__PURE__*/_interopDefaultLegacy(get);
var isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(isEmpty);
var template__default = /*#__PURE__*/_interopDefaultLegacy(template);

var types = ['GET_LOADER', 'GET_LOADER_SUCCESS', 'GET_LOADER_ERROR', 'REMOVE_LOADER', 'REMOVE_LOADER_SUCCESS', 'REMOVE_LOADER_ERROR', 'UPDATE_LOADER', 'UPDATE_LOADER_PRICING_MONETIZATION_TIERS', 'UPDATE_LOADER_GROUP_BILLING_STATUS', 'UPDATE_LOADER_USER', 'UPDATE_LOADER_USER_NEWSLETTERS', 'LOADER_IS_FETCHING', 'LOADER_IS_NOT_FETCHING'];

var creators = function creators(duck) {
  return {
    getLoader: function getLoader(payload) {
      return Object.assign({
        type: duck.types.GET_LOADER
      }, payload);
    },
    getLoaderSuccess: function getLoaderSuccess(payload) {
      return {
        type: duck.types.GET_LOADER_SUCCESS,
        payload: payload
      };
    },
    removeLoader: function removeLoader(payload) {
      return Object.assign({
        type: duck.types.REMOVE_LOADER
      }, payload);
    },
    updateLoader: function updateLoader(payload) {
      return Object.assign({
        type: duck.types.UPDATE_LOADER
      }, payload);
    },
    updateLoaderPricingMonetizationTiers: function updateLoaderPricingMonetizationTiers(payload) {
      return Object.assign({
        type: duck.types.UPDATE_LOADER_PRICING_MONETIZATION_TIERS
      }, payload);
    },
    updateLoaderGroupBillingStatus: function updateLoaderGroupBillingStatus(payload) {
      return Object.assign({
        type: duck.types.UPDATE_LOADER_GROUP_BILLING_STATUS
      }, payload);
    },
    updateLoaderUser: function updateLoaderUser(payload) {
      return Object.assign({
        type: duck.types.UPDATE_LOADER_USER
      }, payload);
    },
    updateLoaderUserNewsletters: function updateLoaderUserNewsletters(payload) {
      return Object.assign({
        type: duck.types.UPDATE_LOADER_USER_NEWSLETTERS
      }, payload);
    },
    loaderIsFetching: function loaderIsFetching(payload) {
      return Object.assign({
        type: duck.types.LOADER_IS_FETCHING
      }, payload);
    },
    loaderIsNotFetching: function loaderIsNotFetching(payload) {
      return Object.assign({
        type: duck.types.LOADER_IS_NOT_FETCHING
      }, payload);
    }
  };
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var initialState = {
  isFetching: false,
  guest: undefined,
  user: undefined
};

var loaderCleaner = function loaderCleaner(_ref) {
  var scope = _ref.scope,
      key = _ref.key,
      payload = _ref.payload;

  if (!payload) {
    return payload;
  } // fix the loader's sometimes null group
  // fix the loader's sometimes null paymentMethods


  if (scope === 'user') {
    if (payload.paymentMethods) {
      var nextState = produce__default['default'](payload, function (draftState) {
        var filteredPaymentMethods = payload.paymentMethods.filter(function (paymentMethod) {
          return paymentMethod !== null;
        });
        draftState.paymentMethods = filteredPaymentMethods;
      });
      return nextState;
    }

    if (key === 'paymentMethods') {
      var _nextState = produce__default['default'](payload, function (draftState) {
        return draftState.filter(function (paymentMethod) {
          return paymentMethod !== null;
        });
      });

      return _nextState;
    }
  }

  return payload;
};

var reducer = function reducer(state, _ref2, duck) {
  var type = _ref2.type,
      payload = _ref2.payload;
  return produce__default['default'](state, function (draftState) {
    switch (type) {
      case duck.types.LOADER_IS_FETCHING:
        draftState.isFetching = true;
        break;

      case duck.types.LOADER_IS_NOT_FETCHING:
        draftState.isFetching = false;
        break;

      case duck.types.GET_LOADER:
        draftState.isFetching = true;
        break;

      case duck.types.GET_LOADER_SUCCESS:
        draftState[payload.scope] = loaderCleaner({
          type: duck.types.GET_LOADER_SUCCESS,
          scope: payload.scope,
          payload: payload.data
        });
        draftState.isFetching = false;
        break;

      case duck.types.GET_LOADER_ERROR:
        draftState.isFetching = false;
        break;

      case duck.types.REMOVE_LOADER_SUCCESS:
        draftState[payload.scope] = undefined;
        break;

      case duck.types.UPDATE_LOADER:
        if (draftState[payload.scope]) {
          draftState[payload.scope] = Object.keys(payload.loader).reduce(function (loader, key) {
            return Object.assign({}, loader, _defineProperty({}, key, loaderCleaner({
              type: duck.types.UPDATE_LOADER,
              scope: payload.scope,
              key: key,
              payload: payload.loader[key]
            })));
          }, draftState[payload.scope]);
        }

        break;

      case duck.types.UPDATE_LOADER_PRICING_MONETIZATION_TIERS:
        if (payload.tiers) {
          if (draftState.guest) {
            draftState.guest.pricing.monetization.cover_photo = payload.cover_photo;
            draftState.guest.pricing.monetization.is_pledge = payload.is_pledge;
            draftState.guest.pricing.monetization.plan_id = payload.plan_id;
            draftState.guest.pricing.monetization.type = payload.type;
            draftState.guest.pricing.monetization.tiers = payload.tiers;
          }

          if (draftState.user) {
            draftState.user.pricing.monetization.cover_photo = payload.cover_photo;
            draftState.user.pricing.monetization.is_pledge = payload.is_pledge;
            draftState.user.pricing.monetization.plan_id = payload.plan_id;
            draftState.user.pricing.monetization.type = payload.type;
            draftState.user.pricing.monetization.tiers = payload.tiers;
          }
        }

        break;

      case duck.types.UPDATE_LOADER_GROUP_BILLING_STATUS:
        if (payload.groupId && payload.billingStatus) {
          if (draftState.guest && draftState.guest.group.id === payload.groupId) {
            draftState.guest.group.billing_status = payload.billingStatus;
          }

          if (draftState.user && draftState.user.group.id === payload.groupId) {
            draftState.user.group.billing_status = payload.billingStatus;
          }
        }

        break;

      case duck.types.UPDATE_LOADER_USER:
        if (payload.user) {
          draftState.user.user = Object.keys(payload.user).reduce(function (loaderUserUser, key) {
            return Object.assign({}, loaderUserUser, _defineProperty({}, key, loaderCleaner({
              type: duck.types.UPDATE_LOADER_USER,
              scope: 'user',
              key: key,
              payload: payload.user[key]
            })));
          }, draftState.user.user);
        }

        break;

      case duck.types.UPDATE_LOADER_USER_NEWSLETTERS:
        if (payload.newsletters) {
          if (draftState.user) {
            draftState.user.newsletters = payload.newsletters;
          }
        }

        if (draftState.user) {
          draftState.user.user.sync = !!payload.sync;
        }

        break;

    }
  });
};

function* getLoader(_ref) {
  var types = _ref.types,
      _ref$scope = _ref.scope,
      scope = _ref$scope === void 0 ? 'guest' : _ref$scope,
      shortCode = _ref.shortCode,
      publisherId = _ref.publisherId,
      _ref$requestPayload = _ref.requestPayload,
      requestPayload = _ref$requestPayload === void 0 ? {} : _ref$requestPayload;

  // 2yy9b4dj, 943w2n8d
  try {
    var response = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: scope === 'user' ? endpoints.LOADER() : endpoints.LOADER_GUEST(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        params: Object.assign({}, shortCode && {
          short_code: shortCode
        }),
        data: requestPayload
      }
    });

    if (!response.data) {
      throw Error('No loader data was recieved');
    }

    if (response.data.widget_disabled) {
      throw Error('whitelisted');
    } // make func - start


    var _response$data = response.data,
        _response$data$pricin = _response$data.pricing,
        pricing = _response$data$pricin === void 0 ? {} : _response$data$pricin,
        group = _response$data.group;

    var _ref2 = pricing || {},
        _ref2$identification = _ref2.identification,
        identification = _ref2$identification === void 0 ? {} : _ref2$identification,
        _ref2$monetization = _ref2.monetization,
        monetization = _ref2$monetization === void 0 ? {} : _ref2$monetization;

    var identificationRuleId = identification.identification_rule_id;
    var planId = monetization.plan_id;

    var _ref3 = group || {},
        groupPlanId = _ref3.plan_id; // make func - end


    var lang = {};
    yield effects.put({
      type: types.GET_LOADER_SUCCESS,
      payload: {
        scope: scope,
        data: Object.assign({}, response.data, {
          lang: lang
        })
      }
    }); // make func - call 3x- start

    try {
      if (groupPlanId) {
        lang.group = yield effects.call(fetchLang, {
          url: "/".concat(process.env.STAGE, "/").concat(publisherId, "/plans/").concat(groupPlanId, "/EN_US.json")
        });
      }
    } catch (error) {
      console.error(error);
    }

    try {
      if (identificationRuleId) {
        lang.rule = yield effects.call(fetchLang, {
          url: "/".concat(process.env.STAGE, "/").concat(publisherId, "/rules/").concat(identificationRuleId, "/EN_US.json")
        });
      }
    } catch (error) {
      console.error(error);
    }

    try {
      if (planId) {
        lang.plan = yield effects.call(fetchLang, {
          url: "/".concat(process.env.STAGE, "/").concat(publisherId, "/plans/").concat(planId, "/EN_US.json")
        });
      }
    } catch (error) {
      console.error(error);
    } // make func - end


    yield effects.put({
      type: types.GET_LOADER_SUCCESS,
      payload: {
        scope: scope,
        data: Object.assign({}, response.data, {
          lang: lang
        })
      }
    });
  } catch (error) {
    console.log(error);
    yield effects.put({
      type: types.GET_LOADER_ERROR,
      error: error.message
    });
  }
}

function* removeLoader(_ref) {
  var types = _ref.types,
      _ref$scope = _ref.scope,
      scope = _ref$scope === void 0 ? 'guest' : _ref$scope;

  try {
    yield effects.put({
      type: types.REMOVE_LOADER_SUCCESS,
      payload: {
        scope: scope
      }
    });
  } catch (error) {
    yield effects.put({
      type: types.REMOVE_LOADER_ERROR,
      error: error.message
    });
  }
}

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var fetchLang = _async(function (_ref) {
  var url = _ref.url;
  return _await(axios__default['default']({
    method: 'get',
    baseURL: endpoints.LANG_URL(),
    timeout: 30000,
    url: url
  }), function (response) {
    if (!response.data) {
      throw Error('no data in response');
    }

    return response.data;
  });
});

var sagas = function sagas(duck) {
  return {
    getLoader: function* getLoader$1(payload) {
      yield getLoader(Object.assign({}, payload, duck));
    },
    removeLoader: function* removeLoader$1(payload) {
      yield removeLoader(Object.assign({}, payload, duck));
    }
  };
};

var takes = function takes(_ref) {
  var types = _ref.types,
      sagas = _ref.sagas;
  return [effects.takeEvery(types.GET_LOADER, sagas.getLoader), effects.takeEvery(types.REMOVE_LOADER, sagas.removeLoader)];
};

var templateCache = {};
var compile = function compile(templateString) {
  var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (templateString === '') {
    console.warn('template failed');
    return null;
  }

  if (!templateCache[templateString]) {
    templateCache[templateString] = template__default['default'](templateString);
  }

  var compiled = templateCache[templateString];
  return compiled(variables);
};
var getTemplateOrDefault = function getTemplateOrDefault(templates, defaults, label) {
  return get__default['default'](templates, label, get__default['default'](defaults, label));
};

/* eslint-disable no-template-curly-in-string */
var donationPlan = {
  customerPromptWithoutName: {
    title: 'Will you renew your support?',
    subtitle: 'Continue funding the content you love.',
    description: null
  },
  customerPromptWithName: {
    title: 'Will you renew your support, ${first_name}?',
    subtitle: 'Continue funding the content you love.',
    description: null
  },
  nonDonorPromptWithoutName: {
    title: 'Thanks for being a loyal member of this community.',
    subtitle: 'Become a donor today to show your support.',
    description: null
  },
  nonDonorPromptWithName: {
    title: 'Thanks for being a loyal member of this community, ${first_name}.',
    subtitle: 'Become a donor today to show your support.',
    description: null
  },
  featureList: {
    show: false,
    title: null,
    list: null
  },
  recurringConfirmationWithoutName: 'Thank you for becoming a sustaining member of our community. Your gift is essential for funding great content on ${publication_name}. When you see our logo in this corner, you can click on it to manage your membership.',
  recurringConfirmationWithName: 'Thank you for becoming a sustaining member of our community, ${first_name}. Your gift is essential for funding great content on ${publication_name}. When you see our logo in this corner, you can click on it to manage your membership.',
  singleConfirmationWithoutName: 'Thank you for being a part of our community of supporters. Your gift is essential for funding great content on ${publication_name}.',
  singleConfirmationWithName: 'Thank you for being a part of our community of supporters, ${first_name}. Your gift is essential for funding great content on ${publication_name}.'
};

/* eslint-disable no-template-curly-in-string */
var subscriptionPlan = {
  promptWithoutName: {
    title: 'Thanks for being a loyal member of this community.',
    subtitle: 'Subscribe now to keep your exclusive access.',
    description: null
  },
  promptWithName: {
    title: 'Thanks for being a loyal member of this community, ${first_name}.',
    subtitle: 'Subscribe now to keep your exclusive access.',
    description: null
  },
  featureList: {
    show: false,
    title: null,
    list: null
  },
  trialConfirmationWithoutName: 'Thank you for trying out a subscription to ${publication_name}. When you see our logo in this corner, you can click on it to manage your subscription.',
  trialConfirmationWithName: 'Thank you for trying out a subscription to ${publication_name}, ${first_name}. When you see our logo in this corner, you can click on it to manage your subscription.',
  confirmationWithoutName: 'Thank you for subscribing to ${publication_name}. When you see our logo in this corner, you can click on it to manage your subscription.',
  confirmationWithName: 'Thank you for subscribing to ${publication_name}, ${first_name}. When you see our logo in this corner, you can click on it to manage your subscription.'
};

var defaultPassPlan = {
  promptWithoutName: {
    title: 'Thanks for being a part of this community.',
    subtitle: 'Buy a pass now to keep your exclusive access.',
    description: null
  },
  promptWithName: {
    title: 'Thanks for being a loyal member of this community, ${first_name}.',
    subtitle: 'Purchase a pass today to get exclusive access to content.',
    description: null
  },
  confirmationWithoutName: 'Your pass has been sucessfully activated! When you see our logo in this corner, you can click on it to manage your membership.',
  confirmationWithName: 'Your pass has been successfully activated, ${first_name}! When you see our logo in this corner, you can click on it to manage your membership.'
};

var DONATION = 'donation';
var SUBSCRIPTION = 'subscription';
var PASS = 'pass';
var retrievePlanPrompt = function retrievePlanPrompt(_ref) {
  var planTemplates = _ref.planTemplates,
      userFirstName = _ref.userFirstName,
      monetizationType = _ref.monetizationType,
      hasPurchased = _ref.hasPurchased;
  var values = {
    title: '',
    subTitle: '',
    description: ''
  };

  if (monetizationType === DONATION) {
    if (hasPurchased) {
      if (userFirstName) {
        values.title = compile(getTemplateOrDefault(planTemplates, donationPlan, 'customerPromptWithName.title'), {
          first_name: userFirstName
        });
        values.subTitle = compile(getTemplateOrDefault(planTemplates, donationPlan, 'customerPromptWithName.subtitle'), {
          first_name: userFirstName
        });
        values.description = compile(getTemplateOrDefault(planTemplates, donationPlan, 'customerPromptWithName.description'), {
          first_name: userFirstName
        });
      } else {
        values.title = getTemplateOrDefault(planTemplates, donationPlan, 'customerPromptWithoutName.title');
        values.subTitle = getTemplateOrDefault(planTemplates, donationPlan, 'customerPromptWithoutName.subtitle');
        values.description = getTemplateOrDefault(planTemplates, donationPlan, 'customerPromptWithoutName.description');
      }
    } else if (userFirstName) {
      values.title = compile(getTemplateOrDefault(planTemplates, donationPlan, 'nonDonorPromptWithName.title'), {
        first_name: userFirstName
      });
      values.subTitle = compile(getTemplateOrDefault(planTemplates, donationPlan, 'nonDonorPromptWithName.subtitle'), {
        first_name: userFirstName
      });
      values.description = compile(getTemplateOrDefault(planTemplates, donationPlan, 'nonDonorPromptWithName.description'), {
        first_name: userFirstName
      });
    } else {
      values.title = getTemplateOrDefault(planTemplates, donationPlan, 'nonDonorPromptWithoutName.title');
      values.subTitle = getTemplateOrDefault(planTemplates, donationPlan, 'nonDonorPromptWithoutName.subtitle');
      values.description = getTemplateOrDefault(planTemplates, donationPlan, 'nonDonorPromptWithoutName.description');
    }
  } else if (monetizationType === SUBSCRIPTION) {
    if (userFirstName) {
      values.title = compile(getTemplateOrDefault(planTemplates, subscriptionPlan, 'promptWithName.title'), {
        first_name: userFirstName
      });
      values.subTitle = compile(getTemplateOrDefault(planTemplates, subscriptionPlan, 'promptWithName.subtitle'), {
        first_name: userFirstName
      });
      values.description = compile(getTemplateOrDefault(planTemplates, subscriptionPlan, 'promptWithName.description'), {
        first_name: userFirstName
      });
    } else {
      values.title = getTemplateOrDefault(planTemplates, subscriptionPlan, 'promptWithoutName.title');
      values.subTitle = getTemplateOrDefault(planTemplates, subscriptionPlan, 'promptWithoutName.subtitle');
      values.description = getTemplateOrDefault(planTemplates, subscriptionPlan, 'promptWithoutName.description');
    }
  } else if (monetizationType === PASS) {
    if (userFirstName) {
      values.title = compile(getTemplateOrDefault(planTemplates, defaultPassPlan, 'promptWithName.title'), {
        first_name: userFirstName
      });
      values.subTitle = compile(getTemplateOrDefault(planTemplates, defaultPassPlan, 'promptWithName.subtitle'), {
        first_name: userFirstName
      });
      values.description = compile(getTemplateOrDefault(planTemplates, defaultPassPlan, 'promptWithName.description'), {
        first_name: userFirstName
      });
    } else {
      values.title = getTemplateOrDefault(planTemplates, defaultPassPlan, 'promptWithoutName.title');
      values.subTitle = getTemplateOrDefault(planTemplates, defaultPassPlan, 'promptWithoutName.subtitle');
      values.description = getTemplateOrDefault(planTemplates, defaultPassPlan, 'promptWithoutName.description');
    }
  }

  return values;
};

/* eslint-disable no-template-curly-in-string */
var requiredRule = {
  menu: {
    title: 'Join the ${publication_name} community.',
    subtitle: 'It’s free, and you’ll get special updates, exclusive content, and more.',
    button: 'Join or Log In'
  },
  prompt: {
    title: 'Log in to continue reading.',
    subtitle: null,
    description: null
  },
  confirmationWithoutName: 'You are now logged in to ${publication_name}.',
  confirmationWithName: 'Hi ${first_name}, you are now logged in to ${publication_name}.'
};

/* eslint-disable no-template-curly-in-string */
var optionalRule = {
  menu: {
    title: 'Join the ${publication_name} community.',
    subtitle: 'It’s free, and you’ll get special updates, exclusive content, and more.',
    button: 'Join or Log In'
  },
  prompt: {
    title: 'Join the ${publication_name} community.',
    subtitle: 'It’s free, and you’ll get special updates, exclusive content, and more.',
    description: null
  },
  confirmationWithoutName: 'You are now logged in to ${publication_name}.',
  confirmationWithName: 'Hi ${first_name}, you are now logged in to ${publication_name}.'
};

var retrieveRulePromptTitle = function retrieveRulePromptTitle(_ref) {
  var ruleTemplates = _ref.ruleTemplates,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required;
  var templateString = '';

  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'prompt.title');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'prompt.title');
  }

  return templateString;
};
var retrieveRulePromptSubtitle = function retrieveRulePromptSubtitle(_ref2) {
  var ruleTemplates = _ref2.ruleTemplates,
      _ref2$required = _ref2.required,
      required = _ref2$required === void 0 ? false : _ref2$required;
  var templateString = '';

  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'prompt.subtitle');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'prompt.subtitle');
  }

  return templateString;
};
var retrieveRulePromptDescription = function retrieveRulePromptDescription(_ref3) {
  var ruleTemplates = _ref3.ruleTemplates,
      _ref3$required = _ref3.required,
      required = _ref3$required === void 0 ? false : _ref3$required;
  var templateString = '';

  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'prompt.description');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'prompt.description');
  }

  return templateString;
};
var retrieveRuleMenuTitle = function retrieveRuleMenuTitle(_ref4) {
  var ruleTemplates = _ref4.ruleTemplates,
      _ref4$required = _ref4.required,
      required = _ref4$required === void 0 ? false : _ref4$required;
  var templateString = '';

  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'menu.title');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'menu.title');
  }

  return templateString;
};
var retrieveRuleMenuSubtitle = function retrieveRuleMenuSubtitle(_ref5) {
  var ruleTemplates = _ref5.ruleTemplates,
      _ref5$required = _ref5.required,
      required = _ref5$required === void 0 ? false : _ref5$required;
  var templateString = '';

  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'menu.subtitle');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'menu.subtitle');
  }

  return templateString;
};
var retrieveRuleMenuAction = function retrieveRuleMenuAction(_ref6) {
  var ruleTemplates = _ref6.ruleTemplates,
      _ref6$required = _ref6.required,
      required = _ref6$required === void 0 ? false : _ref6$required;
  var templateString = '';

  if (required) {
    templateString = getTemplateOrDefault(ruleTemplates, requiredRule, 'menu.button');
  } else {
    templateString = getTemplateOrDefault(ruleTemplates, optionalRule, 'menu.button');
  }

  return templateString;
};
var getHeaderDescription = function getHeaderDescription(loader) {
  switch (loader && loader.pricing && loader.pricing.monetization && loader.pricing.monetization.type && loader.pricing.monetization.type) {
    case 'pass':
      return 'Already a pass holder?';

    case 'donation':
      return 'Already a donor?';

    case 'subscription':
      if (loader && loader.pricing && loader.pricing.monetization && loader.pricing.monetization.is_pledge) {
        return 'Already a member?';
      }

      return 'Already a subscriber?';

    case 'group':
      return 'Already have an account?';

    default:
      return 'Already have an account?';
  }
};

var sortByKey = function sortByKey(items, key) {
  return items.slice().sort(function (a, b) {
    return a[key] - b[key];
  });
};

var selectorsDefault = (function (duck) {
  return {
    loader: function loader(state) {
      return state.loader;
    },
    topScopeLoader: function topScopeLoader(state) {
      return state[duck.store].user || state[duck.store].guest || {};
    },
    hasGuestLoader: function hasGuestLoader(state) {
      return !!state[duck.store].guest;
    },
    hasUserLoader: function hasUserLoader(state) {
      return !!state[duck.store].user;
    },
    memberType: function memberType(state) {
      var isPledge = duck.selectors.monetizationIsPledge(state);

      if (isPledge) {
        return 'member';
      }

      var isSubscription = duck.selectors.monetizationTypeIsSubscription(state);

      if (isSubscription) {
        return 'subscriber';
      }

      var isPass = duck.selectors.monetizationTypeIsPass(state);

      if (isPass) {
        return 'pass holder';
      }

      var isDonation = duck.selectors.monetizationTypeIsDonation(state);

      if (isDonation) {
        return 'donor';
      }

      return null;
    },
    userWindowObject: function userWindowObject(state) {
      var id = duck.selectors.userId(state);
      var email = duck.selectors.userEmail(state);
      var authenticated = duck.selectors.userAuth(state);
      var first_name = duck.selectors.userFirstName(state);
      var last_name = duck.selectors.userLastName(state);
      var membership_type = duck.selectors.currentSubscriptionType(state);
      var tier = duck.selectors.currentSubscriptionPlanTierTitle(state);
      var group_name = duck.selectors.groupName(state);
      var total_paid = duck.selectors.currentBillingIntervalTotalPaid(state);
      var recurring_payment = duck.selectors.currentSubscriptionPrice(state);
      var verified = duck.selectors.userVerified(state);
      return {
        id: id,
        authenticated: authenticated,
        email: email,
        verified: verified,
        first_name: first_name,
        last_name: last_name,
        membership_type: membership_type,
        tier: tier,
        group_name: group_name,
        total_paid: total_paid,
        recurring_payment: recurring_payment
      };
    },
    // -----
    // Used In
    // Account menu - Notification.KeepPlan.js (pass holder excluded)
    // -----
    memberNoun: function memberNoun(state) {
      var memberType = duck.selectors.memberType(state);

      switch (memberType) {
        case 'member':
          return 'membership';

        case 'subscriber':
          return 'subscription';

        case 'pass holder':
          return 'pass';

        case 'donor':
          return 'contribution';

      }

      return '';
    },
    // -----
    // Used In
    // Account menu - ManagePlan.Subscription.StopSubscription (pass holder excluded)
    // -----
    memberVerbPresentParticiple: function memberVerbPresentParticiple(state) {
      var memberType = duck.selectors.memberType(state);

      switch (memberType) {
        case 'member':
          return 'your membership';

        case 'subscriber':
          return 'subscribing';

        case 'pass holder':
          return 'your pass';

        case 'donor':
          return 'contributing';

      }

      return '';
    },
    publisherId: function publisherId(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.id) {
        return null;
      }

      return loader.publisher.id;
    },
    publisherName: function publisherName(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.name) {
        return null;
      }

      return loader.publisher.name;
    },
    publisherIcon: function publisherIcon(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.icon) {
        return null;
      }

      return loader.publisher.icon;
    },
    publisherUrl: function publisherUrl(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.url) {
        return null;
      }

      return loader.publisher.url;
    },
    supportEmail: function supportEmail(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.support_email) {
        return null;
      }

      return loader.publisher.support_email;
    },
    userFullName: function userFullName(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.full_name;
    },
    userFirstName: function userFirstName(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.first_name;
    },
    userLastName: function userLastName(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.last_name;
    },
    userEmail: function userEmail(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.email;
    },
    userAuth: function userAuth(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return false;
      }

      return state[duck.store].user.user.auth;
    },
    userId: function userId(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.id;
    },
    userHasPassword: function userHasPassword(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.has_password;
    },
    userAvatarUrl: function userAvatarUrl(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      return state[duck.store].user.user.avatar_url;
    },
    userInitials: function userInitials(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return null;
      }

      var user = state[duck.store].user.user;
      return isEmpty__default['default'](user.initials) ? user.email[0] : user.initials;
    },
    userStatus: function userStatus(state) {
      var has_purchase = duck.selectors.userHasCurrentPurchases(state);
      var registered = duck.selectors.userId(state);
      var is_group_member = duck.selectors.isGroupMember(state);
      var has_rule = duck.selectors.pricingHasIdentification(state);

      if (has_purchase || is_group_member) {
        return 'paying';
      } else if (registered) {
        return 'registered';
      } else if (!has_rule) {
        return 'excluded';
      }

      return 'anonymous';
    },
    userVerified: function userVerified(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return false;
      }

      return state[duck.store].user.user.verified;
    },
    userSyncNewsletters: function userSyncNewsletters(state) {
      if (!state[duck.store].user || !state[duck.store].user.user) {
        return false;
      }

      return state[duck.store].user.user.sync;
    },
    currentSubscriptionPrice: function currentSubscriptionPrice(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_price) {
        return null;
      }

      return state[duck.store].user.purchases.current.subscription_price;
    },
    currentSubscriptionType: function currentSubscriptionType(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_type) {
        return null;
      }

      return state[duck.store].user.purchases.current.subscription_type;
    },
    currentSubscriptionTypeIsPass: function currentSubscriptionTypeIsPass(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_type) {
        return false;
      }

      return state[duck.store].user.purchases.current.subscription_type === 'pass';
    },
    currentSubscriptionTypeIsRecurringDonation: function currentSubscriptionTypeIsRecurringDonation(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_type) {
        return false;
      }

      return state[duck.store].user.purchases.current.subscription_type === 'recurring-donation';
    },
    currentSubscriptionTypeIsSubscription: function currentSubscriptionTypeIsSubscription(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_type) {
        return false;
      }

      return state[duck.store].user.purchases.current.subscription_type === 'subscription';
    },
    currentSubscriptionIsTrial: function currentSubscriptionIsTrial(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current) {
        return false;
      }

      return state[duck.store].user.purchases.current.subscription_trial_end !== null;
    },
    currentSubscriptionStart: function currentSubscriptionStart(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_start) {
        return null;
      }

      return state[duck.store].user.purchases.current.subscription_start;
    },
    currentPlanTierId: function currentPlanTierId(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.plan_tier_id) {
        return null;
      }

      return state[duck.store].user.purchases.current.plan_tier_id;
    },
    currentPlanOptionId: function currentPlanOptionId(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.plan_option_id) {
        return null;
      }

      return state[duck.store].user.purchases.current.plan_option_id;
    },
    currentPlanOptionCurrency: function currentPlanOptionCurrency(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.plan_option_currency) {
        return null;
      }

      return state[duck.store].user.purchases.current.plan_option_currency;
    },
    currentSubscriptionId: function currentSubscriptionId(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_id) {
        return null;
      }

      return state[duck.store].user.purchases.current.subscription_id;
    },
    currentSubscriptionIdIsGift: function currentSubscriptionIdIsGift(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_id) {
        return false;
      }

      return state[duck.store].user.purchases.current.subscription_id === 'GIFT';
    },
    currentSubscriptionEnd: function currentSubscriptionEnd(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.subscription_end) {
        return null;
      }

      return state[duck.store].user.purchases.current.subscription_end;
    },
    currentSubscriptionPlanTierTitle: function currentSubscriptionPlanTierTitle(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.plan_tier_title) {
        return null;
      }

      return state[duck.store].user.purchases.current.plan_tier_title;
    },
    currentPurchaseCanceled: function currentPurchaseCanceled(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.status) {
        return null;
      }

      return state[duck.store].user.purchases.current.status === 'CANCELED';
    },
    currentPurchaseActive: function currentPurchaseActive(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.status) {
        return null;
      }

      return state[duck.store].user.purchases.current.status === 'ACTIVE';
    },
    currentPurchaseFailed: function currentPurchaseFailed(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current || !state[duck.store].user.purchases.current.status) {
        return null;
      }

      return state[duck.store].user.purchases.current.status === 'FAILED';
    },
    updatePaymentMethodText: function updatePaymentMethodText(state) {
      var memberType = duck.selectors.memberType(state);

      switch (memberType) {
        case 'member':
        case 'subscriber':
          return 'Please update your payment method to restore subscription benefits.';

        case 'donor':
          return 'Please update your payment method to restore your donation.';

      }

      return '';
    },
    badgePaymentMethod: function badgePaymentMethod(state) {
      var _state$duck$store, _state$duck$store$use, _state$duck$store$use2;

      var firstPaymentMethod = state === null || state === void 0 ? void 0 : (_state$duck$store = state[duck.store]) === null || _state$duck$store === void 0 ? void 0 : (_state$duck$store$use = _state$duck$store.user) === null || _state$duck$store$use === void 0 ? void 0 : (_state$duck$store$use2 = _state$duck$store$use.paymentMethods) === null || _state$duck$store$use2 === void 0 ? void 0 : _state$duck$store$use2[0];

      if (!firstPaymentMethod || !(firstPaymentMethod !== null && firstPaymentMethod !== void 0 && firstPaymentMethod.cardType) || !(firstPaymentMethod !== null && firstPaymentMethod !== void 0 && firstPaymentMethod.last4)) {
        return null;
      }

      return {
        cardType: firstPaymentMethod.cardType,
        last4: firstPaymentMethod.last4
      };
    },
    nextPlanSubscriptionStart: function nextPlanSubscriptionStart(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.next_plan || !state[duck.store].user.purchases.history.next_plan.subscription_start) {
        return null;
      }

      return state[duck.store].user.purchases.history.next_plan.subscription_start;
    },
    nextPlanSubscriptionEnd: function nextPlanSubscriptionEnd(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.next_plan || !state[duck.store].user.purchases.history.next_plan.subscription_end) {
        return null;
      }

      return state[duck.store].user.purchases.history.next_plan.subscription_end;
    },
    nextPlanStatusNext: function nextPlanStatusNext(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.next_plan || !state[duck.store].user.purchases.history.next_plan.status) {
        return false;
      }

      return state[duck.store].user.purchases.history.next_plan.status === 'NEXT';
    },
    nextPlanPlanOptionPrice: function nextPlanPlanOptionPrice(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.next_plan || !state[duck.store].user.purchases.history.next_plan.plan_option_price) {
        return null;
      }

      return state[duck.store].user.purchases.history.next_plan.plan_option_price;
    },
    nextPlanPlanOptionInterval: function nextPlanPlanOptionInterval(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.next_plan || !state[duck.store].user.purchases.history.next_plan.plan_option_interval) {
        return null;
      }

      return state[duck.store].user.purchases.history.next_plan.plan_option_interval;
    },
    firstDonation: function firstDonation(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.first_donation) {
        return null;
      }

      return state[duck.store].user.purchases.history.first_donation;
    },
    currentBillingIntervalTotalPaid: function currentBillingIntervalTotalPaid(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.current_billing_interval_total_paid) {
        return null;
      }

      return state[duck.store].user.purchases.history.current_billing_interval_total_paid;
    },
    originalEnrollmentDate: function originalEnrollmentDate(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.originalEnrollmentDate) {
        return null;
      }

      return state[duck.store].user.purchases.history.originalEnrollmentDate;
    },
    nextPlan: function nextPlan(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.history || !state[duck.store].user.purchases.history.next_plan || Object.keys(state[duck.store].user.purchases.history.next_plan).length === 0) {
        return null;
      }

      return state[duck.store].user.purchases.history.next_plan;
    },
    pricingHasIdentification: function pricingHasIdentification(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader || !loader.pricing || !loader.pricing.identification || Object.keys(loader.pricing.identification).length === 0) {
        return false;
      }

      return true;
    },
    pricingHasMonetization: function pricingHasMonetization(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader || !loader.pricing || !loader.pricing.monetization || Object.keys(loader.pricing.monetization).length === 0 || !loader.pricing.monetization.type) {
        return false;
      }

      return true;
    },
    monetizationIsPledge: function monetizationIsPledge(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader || !loader.pricing || !loader.pricing.monetization || !loader.pricing.monetization.is_pledge) {
        return false;
      }

      return loader.pricing.monetization.is_pledge;
    },
    monetizationBillingStatus: function monetizationBillingStatus(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader || !loader.pricing || !loader.pricing.monetization || !loader.pricing.monetization.billing_status) {
        return null;
      }

      return loader.pricing.monetization.billing_status;
    },
    userHasCurrentPurchases: function userHasCurrentPurchases(state) {
      if (!state[duck.store].user || !state[duck.store].user.purchases || !state[duck.store].user.purchases.current) {
        return false;
      }

      return Object.keys(state[duck.store].user.purchases.current).length > 0;
    },
    monetizationTypeIsSubscription: function monetizationTypeIsSubscription(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader || !loader.pricing || !loader.pricing.monetization || !loader.pricing.monetization.type) {
        return false;
      }

      return loader.pricing.monetization.type === 'subscription';
    },
    monetizationTypeIsDonation: function monetizationTypeIsDonation(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader || !loader.pricing || !loader.pricing.monetization || !loader.pricing.monetization.type) {
        return false;
      }

      return loader.pricing.monetization.type === 'donation';
    },
    monetizationTypeIsGroup: function monetizationTypeIsGroup(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader || !loader.pricing || !loader.pricing.monetization || !loader.pricing.monetization.type) {
        return false;
      }

      return loader.pricing.monetization.type === 'group';
    },
    monetizationTypeIsPass: function monetizationTypeIsPass(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader || !loader.pricing || !loader.pricing.monetization || !loader.pricing.monetization.type) {
        return false;
      }

      return loader.pricing.monetization.type === 'pass';
    },
    isGroupAdmin: function isGroupAdmin(state) {
      if (!state[duck.store].user || !state[duck.store].user.group || !state[duck.store].user.group.admin) {
        return false;
      }

      return state[duck.store].user.group.admin;
    },
    isGroupMember: function isGroupMember(state) {
      if (!state[duck.store].user || !state[duck.store].user.group || !state[duck.store].user.group.member) {
        return false;
      }

      return state[duck.store].user.group.member;
    },
    groupName: function groupName(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader || !loader.group || !loader.group.name) {
        return null;
      }

      return loader.group.name;
    },
    groupSize: function groupSize(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader || !loader.group || !loader.group.size) {
        return null;
      }

      return loader.group.size;
    },
    userHasGroupData: function userHasGroupData(state) {
      if (!state[duck.store].user || !state[duck.store].user.group) {
        return false;
      }

      return Object.keys(state[duck.store].user.group).length > 1;
    },
    linkColor: function linkColor(state) {
      var loader = duck.selectors.topScopeLoader(state);

      if (!loader.publisher || !loader.publisher.styling || !loader.publisher.styling.linkColor) {
        return '';
      }

      return loader.publisher.styling.linkColor;
    },
    scopedLoader: function scopedLoader(state, scope) {
      return state.loader[scope];
    },
    isPledge: new Duck__default['default'].Selector(function (selectors) {
      return function (state) {
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'guest';
        return get__default['default'](selectors.scopedLoader(state, scope), 'pricing.monetization.is_pledge', false);
      };
    }),
    tiers: new Duck__default['default'].Selector(function (selectors) {
      return function (state) {
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'guest';
        return get__default['default'](selectors.scopedLoader(state, scope), 'pricing.monetization.tiers', []);
      };
    }),
    tiersSorted: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.tiers, function (items) {
        return sortByKey(items, 'tierOrder');
      });
    }),
    planTexts: new Duck__default['default'].Selector(function (selectors) {
      return function (state) {
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'guest';
        var loader = selectors.scopedLoader(state, scope);

        if (loader && loader.pricing && loader.pricing.monetization) {
          var monetizationType = loader.pricing.monetization.type;
          var hasPurchased = loader.purchases && loader.purchases.history && loader.purchases.history.has_purchased;
          var planTemplates = loader.lang.plan;
          var userFirstName = loader.user.first_name;
          var texts = retrievePlanPrompt({
            planTemplates: planTemplates,
            userFirstName: userFirstName,
            monetizationType: monetizationType,
            hasPurchased: hasPurchased
          });
          return texts;
        }

        return null;
      };
    }),
    ruleTexts: new Duck__default['default'].Selector(function (selectors) {
      return function (state) {
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'guest';
        var loader = selectors.scopedLoader(state, scope);

        if (loader) {
          var values = Object.assign({
            prompt: {
              title: '',
              subTitle: '',
              description: ''
            },
            menu: {
              title: '',
              subTitle: '',
              button: ''
            }
          }, scope === 'guest' && {
            headerDescription: getHeaderDescription(loader)
          });
          var ruleTemplates = loader.lang.rule;
          var publicationName = loader.publisher.name;
          values.prompt.title = compile(retrieveRulePromptTitle({
            ruleTemplates: ruleTemplates
          }), {
            publication_name: publicationName
          });
          values.prompt.subTitle = retrieveRulePromptSubtitle({
            ruleTemplates: ruleTemplates
          });
          values.prompt.description = retrieveRulePromptDescription({
            ruleTemplates: ruleTemplates
          });
          values.menu.title = compile(retrieveRuleMenuTitle({
            ruleTemplates: ruleTemplates
          }), {
            publication_name: publicationName
          });
          values.menu.subTitle = retrieveRuleMenuSubtitle({
            ruleTemplates: ruleTemplates
          });
          values.menu.button = retrieveRuleMenuAction({
            ruleTemplates: ruleTemplates
          });
          return values;
        }

        return null;
      };
    }),
    featureList: new Duck__default['default'].Selector(function (selectors) {
      return function (state) {
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'guest';
        return get__default['default'](selectors.scopedLoader(state, scope), 'lang.plan.tiers', []);
      };
    }),
    pubPriceChangeDate: function pubPriceChangeDate(state) {
      var _loader$purchases, _loader$purchases$his;

      var loader = duck.selectors.topScopeLoader(state);
      var changes = loader === null || loader === void 0 ? void 0 : (_loader$purchases = loader.purchases) === null || _loader$purchases === void 0 ? void 0 : (_loader$purchases$his = _loader$purchases.history) === null || _loader$purchases$his === void 0 ? void 0 : _loader$purchases$his.changes;

      if (!changes) {
        return null;
      }

      var changeDate = changes.reduce(function (acc) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            logType = _ref.logType,
            loggedAt = _ref.loggedAt;

        if (acc) {
          return acc;
        }

        if (logType === 'PUB_PRICE_CHANGE') {
          return loggedAt;
        }

        return acc;
      }, null);
      return changeDate;
    }
  };
});

var storeDefault = 'loader';
var index = (function (_ref) {
  var _ref$store = _ref.store,
      store = _ref$store === void 0 ? storeDefault : _ref$store,
      createDuck = _ref.createDuck,
      _ref$initialState = _ref.initialState,
      initialState$1 = _ref$initialState === void 0 ? initialState : _ref$initialState,
      _ref$creators = _ref.creators,
      creators$1 = _ref$creators === void 0 ? creators : _ref$creators,
      _ref$types = _ref.types,
      types$1 = _ref$types === void 0 ? types : _ref$types,
      _ref$reducer = _ref.reducer,
      reducer$1 = _ref$reducer === void 0 ? reducer : _ref$reducer,
      _ref$sagas = _ref.sagas,
      sagas$1 = _ref$sagas === void 0 ? sagas : _ref$sagas,
      _ref$takes = _ref.takes,
      takes$1 = _ref$takes === void 0 ? takes : _ref$takes,
      _ref$selectors = _ref.selectors,
      selectors = _ref$selectors === void 0 ? selectorsDefault : _ref$selectors;
  return createDuck({
    store: store,
    initialState: initialState$1
  }).extend({
    creators: creators$1,
    types: types$1,
    reducer: reducer$1,
    sagas: sagas$1,
    takes: takes$1,
    selectors: selectors
  });
});

exports.creators = creators;
exports.default = index;
exports.initialState = initialState;
exports.reducer = reducer;
exports.sagas = sagas;
exports.selectors = selectorsDefault;
exports.store = storeDefault;
exports.takes = takes;
exports.types = types;
